import Vue from 'vue'
import Router from 'vue-router'
import MainFrame from '@/components/MainFrame'
import Login from '@/components/Login'

//数据面板
import Dashboard from '@/components/Dashboard/Dashboard'


import lotteryList from '@/components/Set/Lottery/lotteryList'
import Service from '@/components/Set/Service/Service'
import Notice from '@/components/Set/Notice/Notice'
import Config from '@/components/Set/Config/Config'
import Banner from '@/components/Set/Banner/Banner'
import Version from '@/components/Set/Version/Version'
import Suggest from '@/components/Suggest/Suggest'
import shopList from '@/components/Shop/shopList'
import shopAuthList from '@/components/Shop/shopAuthList'

import UserList from '@/components/User/userList'
import userPay from '@/components/User/userPay'
import userDraw from '@/components/User/userDraw'
import AgentList from '@/components/User/agentList'
import nickApply from '@/components/User/nickApply'
import avatarApply from '@/components/User/avatarApply'
import PayinRecord from '@/components/Recharge/PayinRecord'
import DrawRecord from '@/components/Recharge/DrawRecord'
import PayList from '@/components/Recharge/payList'
import DrawList from '@/components/Recharge/drawList'
import ApplyRecord from '@/components/Recharge/ApplyRecord'
import RechargeRecord from '@/components/Record/rechargeRecord'
import ActionRecord from '@/components/Record/actionRecord'
import sendRecord from '@/components/Record/sendRecord'
import OrderList from '@/components/Order/orderList'
import FollowList from '@/components/Order/FollowList'

import shopPayChannel from '@/components/Recharge/shopPayChannel'
import usdtRecord from '@/components/Recharge/usdtRecord'
import payRecord from '@/components/Recharge/payRecord'
import usdtAddress from '@/components/Recharge/usdtAddress'

import vFollowList from '@/components/virtual/FollowList'
import virtualUser from '@/components/virtual/virtualUser'

import virtualApply from '@/components/virtual/virtualApply'

import ossList from '@/components/Dev/ossList'
import apiUrl from '@/components/Dev/apiUrl'


import oFootball from '@/components/Open/Football'
import oBasketball from '@/components/Open/Basketball'
import oPeking from '@/components/Open/Peking'
import oWinlose from '@/components/Open/Winlose'

import AdminPayRecord from '@/components/Recharge/AdminPayRecord'

import AiTemplate from '@/components/Set/AI/AiTemplate'

import App from '@/App.vue'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 处理错误 跳转到重复路径上，忽略错误
    // console.error(err);
  });
};

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'App',
      component: App,
	  children:[
		  {
			path:'',
			component: MainFrame,
		  },
		  {
			name: 'Home',
			path: 'Home',
			component: MainFrame,
			children:[
				{
					path:'/Recharge/AdminPayRecord',
					name:'AdminPayRecord',
					component:AdminPayRecord,
				},{
					path:'/Open/Winlose',
					name:'oWinlose',
					component:oWinlose,
				},{
					path:'/Open/Football',
					name:'oFootball',
					component:oFootball,
				},{
					path:'/Open/Peking',
					name:'oPeking',
					component:oPeking,
				},{
					path:'/Open/Basketball',
					name:'oBasketball',
					component:oBasketball,
				},
				{
					path:'/virtual/virtualUser',
					name:'virtualUser',
					component:virtualUser,
				},
				{
					path:'/virtual/FollowList',
					name:'vFollowList',
					component:vFollowList,
				},{
					path:'/virtualApply',
					name:'virtualApply',
					component:virtualApply
				},{
					path: '/AiTemplate',
					name: 'AiTemplate',
					component: AiTemplate
				},
				{
					path:'/Suggest',
					name:'Suggest',
					component:Suggest
				},{
					path:'/Dashboard',
					name:'Dashboard',
					component:Dashboard
				},{
					path:'/Set/lotteryList',
					name:'lotteryList',
					component:lotteryList
				},{
					path:'/Set/Service',
					name:'Service',
					component:Service
				},{
					path:'/Set/Notice',
					name:'Notice',
					component:Notice
				},{
					path:'/Set/Config',
					name:'Config',
					component:Config
				},{
					path:'/Set/Banner',
					name:'Banner',
					component:Banner
				},{
					path:'/User/userList',
					name:'UserList',
					component:UserList
				},{
					path:'/User/agentList',
					name:'AgentList',
					component:AgentList
				},{
					path:'/User/userPay',
					name:'userPay',
					component:userPay
				},{
					path:'/User/nick',
					name:'nick',
					component:nickApply
				},{
					path:'/User/avatar',
					name:'avatar',
					component:avatarApply
				},{
					path:'/User/userDraw',
					name:'userDraw',
					component:userDraw
				},{
					path:'/Recharge/payList',
					name:'PayList',
					component:PayList
				},{
					path:'/Recharge/drawList',
					name:'DrawList',
					component:DrawList
				},{
					path:'/Recharge/usdtAddress',
					name:'usdtAddress',
					component:usdtAddress
				},{
					path:'/Order/orderList',
					name:'OrderList',
					component:OrderList
				},{
					path:'/Order/followList',
					name:'FollowList',
					component:FollowList
				},{
					path:'/Record/actionRecord',
					name:'ActionRecord',
					component:ActionRecord
				},{
					path:'/Record/sendRecord',
					name:'sendRecord',
					component:sendRecord
				},{
					path:'/Record/rechargeRecord',
					name:'RechargeRecord',
					component:RechargeRecord
				},{
					path:'/Recharge/payRecord',
					name:'payRecord',
					component:payRecord
				},{
					path:'/Recharge/usdtRecord',
					name:'usdtRecord',
					component:usdtRecord
				},{
					path:'/Set/Version',
					name:'Version',
					component:Version
				},{
					path:'/Recharge/DrawRecord',
					name:'DrawRecord',
					component:DrawRecord
				},{
					path:'/Recharge/shopPayChannel',
					name:'shopPayChannel',
					component:shopPayChannel
				},{
					path:'/Recharge/ApplyRecord',
					name:'ApplyRecord',
					component:ApplyRecord
				},{
					path:'/Recharge/PayinRecord',
					name:'PayinRecord',
					component:PayinRecord
				},{
					path:'/shopAuthList',
					name:'shopAuthList',
					component:shopAuthList
				},{
					path:'/shopList',
					name:'shopList',
					component:shopList
				},{
					path:'/Dev/ossList',
					name:'ossList',
					component:ossList
				},{
					path:'/Dev/apiUrl',
					name:'apiUrl',
					component:apiUrl
				}
			]
		  }
	  ]
    },{
      path: '/Login',
      name: 'Login',
      component: Login
    }
  ]
})
